import { Components, Theme, alpha, darken } from '@mui/material';

const components: Components<Omit<Theme, 'components'>>['MuiAlert'] = {
  styleOverrides: {
    root: ({ theme: { palette, spacing, breakpoints }, ownerState }) => ({
      borderRadius: 8,
      padding: spacing(3.5),
      [breakpoints.down('lg')]: {
        padding: spacing(2.5)
      },
      '& .MuiAlert-icon': ownerState?.color
        ? {
            color:
              palette[ownerState.color][
                palette.mode === 'dark' ? 'A60' : 'A100'
              ]
          }
        : {},
      '& .MuiAlert-action': {
        width: 34,
        position: 'relative',
        color: palette.textColor.A60
      },
      '& .MuiAlert-action .MuiButtonBase-root': {
        position: 'absolute',
        right: 4,
        top: -4
      }
    }),
    message: ({ theme: { palette, breakpoints }, ownerState }) => ({
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '24px',
      padding: 0,
      color:
        palette.mode === 'light'
          ? palette.textColor.A80
          : palette[ownerState?.color || 'info']?.A20,
      [breakpoints.down('lg')]: {
        fontSize: 12,
        lineHeight: '20px'
      }
    }),
    icon: ({ theme }) => ({
      padding: 0,
      fontSize: 20,
      marginRight: theme.spacing(3),
      [theme.breakpoints.down('lg')]: {
        marginRight: theme.spacing(1.5)
      }
    }),
    filled: ({ theme: { palette }, ownerState }) => ({
      backgroundColor:
        palette.mode === 'light'
          ? // @ts-ignore
            palette[ownerState.color]?.A20
          : darken(
              // @ts-ignore
              alpha(palette[ownerState.color].A100 as string, 0.1),
              0.1
            )
    }),
    outlined: ({ theme, ownerState }) => ({
      border: `1px solid ${
        theme.palette[ownerState?.color || 'info'][
          theme.palette.mode === 'dark' ? 'A60' : 'A100'
        ]
      }`
    }),
    standard: {
      background: 'none'
    }
  },
  variants: [
    {
      props: { square: true },
      style: {
        borderRadius: 0
      }
    }
  ]
};

export default { components };
